var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45939 2.19178L3.29667 1.0411L3.67968 0.657534C3.78455 0.552511 3.91341 0.5 4.06625 0.5C4.21891 0.5 4.34768 0.552511 4.45255 0.657534L4.83557 1.0411C4.94044 1.14612 4.99516 1.27288 4.99971 1.42137C5.00427 1.56968 4.95412 1.69635 4.84925 1.80137L4.45939 2.19178ZM0.273582 5.5C0.196067 5.5 0.131137 5.4737 0.0787917 5.4211C0.0262639 5.36868 0 5.30365 0 5.22603V4.45205C0 4.41552 0.00683957 4.38018 0.0205187 4.34603C0.0341978 4.31169 0.0547164 4.28082 0.0820746 4.25342L2.89997 1.43151L4.0627 2.59589L1.2448 5.41781C1.21744 5.44521 1.18671 5.46575 1.1526 5.47945C1.11831 5.49315 1.08293 5.5 1.04645 5.5H0.273582Z",
    fill: "#00A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.bf5e358e2b6de750062e0f04fdd83d90.svg";
export { ForwardRef as ReactComponent };